<template>
    <div class="appHeader">
        <div class="left">
            <a href="#" class="headerButton goBack">
                <ion-icon name="chevron-back-outline"></ion-icon>
            </a>
        </div>
        <div class="pageTitle">Soporte</div>
        <div class="right">
        </div>
    </div>
    <div id="appCapsule">
        <iframe frameborder="0" src="https://ayuda.sombrerowallet.com/"></iframe>
    </div>
</template>

<script>
export default {
    data() {
        return {
        };
    },
    mounted() {
        this.$root.loadBackButtom();
    },
    methods: {
    }
}
</script>